export const SYSTEM_RULE_START_OF_SHIFT_MESSAGE_ERROR =
  'System Rules conflict: This job can’t be assigned to the callsign at the start of the shift'
export const SYSTEM_RULE_END_OF_SHIFT_MESSAGE_ERROR =
  'System Rules conflict: This job can’t be assigned to the callsign at the end of the shift'
export const END_OF_SHIFT_CONFIRMATION_MESSAGE =
  'Are you sure you want to assign the job at the end of the shift?'
export const START_OF_SHIFT_CONFIRMATION_MESSAGE =
  'Are you sure you want to assign the job at the start of the shift?'

const SYSTEM_RULE_MESSAGES_MAPPING = new Map()
SYSTEM_RULE_MESSAGES_MAPPING.set(
  SYSTEM_RULE_START_OF_SHIFT_MESSAGE_ERROR,
  START_OF_SHIFT_CONFIRMATION_MESSAGE
)
SYSTEM_RULE_MESSAGES_MAPPING.set(
  SYSTEM_RULE_END_OF_SHIFT_MESSAGE_ERROR,
  END_OF_SHIFT_CONFIRMATION_MESSAGE
)

export { SYSTEM_RULE_MESSAGES_MAPPING }
